<template>
  <div>
    <!--    订单入金待确认 -->
    <baseBreadcrumb :page="$t('message.orderDepositToBeConfirmed')" :menu="$t('message.orderForm')" />
    <orderMain status="40" />
  </div>
</template>
<script>
import orderMain from "@/components/order/baseTable/index.vue";
export default {
  components: {
    orderMain,
  },
  data() {
    return {};
  },
};
</script>
<style lang='scss' scoped></style>